import { useEffect, useState } from 'react'
import { Card, CardBody } from 'react-bootstrap'
import SchoolRequest from './SchoolRequests/SchoolRequest'
import TopSchool from './TopSchools/TopSchool'
import Recent from './Recent/Recent'
import axios from 'axios'
import "./home.css"
import DemoRequest from './DemoRequest'
import Activity from './Activity/Activity'
import { useSelector } from 'react-redux';

const Home = () => {
    const userData = useSelector((state) => state.auth.userData);
    const baseUrl = process.env.REACT_APP_API_URL
    const authentication_key = localStorage.getItem('authentication_key');
    const headers = {
        'Authentication_key': authentication_key,
        'Authorization': 'Bearer ' + authentication_key
    };
    const [recentCurriculum, setRecentCurriculum] = useState("")
    const [curriculumData, setCurriculumData] = useState("")
    const [activityData, setActivityData] = useState([])
    const [load, setLoad] = useState(false)

    const handleGetDashboardData = () => {
        setLoad(true)
        axios.get(`${baseUrl}/partner/curriculum-dashboard`, {
            headers
        }).then(res => {
            const response = res.data
            if (response.status === "success") {
                const data = response.data
                if (data) {
                    setRecentCurriculum(data.recent_curriculum)
                    setCurriculumData(data.curriculum_data)
                    setActivityData(data.recent_curriculum)
                }
                setLoad(false)
            } else {
                console.log(response.message)
                setLoad(false)
            }
        }
        ).catch(err => {
            console.log(err)
            setLoad(false)
        })

    }

    useEffect(() => {
        handleGetDashboardData()
    }, [])

    return (
        <div>
            <Card>
                <CardBody className='d-flex justify-content-between flex-wrap p-3'>
                    <div>
                        <div className='page-heading mb-1' style={{
                            color: "var(--primary)",
                            fontWeight: "500"
                        }} >Welcome {userData?.user_data?.name}!</div>
                        {/* <span style={{ fontSize: '16px', color: "rgba(131, 131, 131, 1)" }}>Home</span> */}
                    </div>
                    {/* <div className='d-flex flex-wrap overflow-auto align-items-center gap'>
                        <div className='d-flex align-items-center home-input-section'>
                            < img src={search} />
                            <input type='text' placeholder='Search' />
                        </div>
                        <ButtonComponent buttonType={"secondary"} title={"Take a tour"} />
                        <div >
                            <img src={lang} />
                        </div>
                        <div>
                            <img src={dashboard} />
                        </div>
                    </div> */}
                </CardBody>

            </Card>
            <div className='mt-4 d-flex gap  flex-wrap'>
                <div style={{ flex: 1 }}>
                    <DemoRequest/>
                    <Recent data={recentCurriculum} load={load} />
                    {/* <Status data={curriculumData} load={load} /> */}
                </div>
                <div style={{ flex: 1 }}>
                    <TopSchool />
                    <div className='mt-4'>
                    <SchoolRequest />
                    <Activity />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home